export * from './angularx-qrcode.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularx-qrcode/dist/components/angularx-qrcode/index.js
// module id = 221
// module chunks = 0